import { List } from 'immutable';

import {
  NODE_TYPE as NT,
  MARK_TYPE as MT,
} from 'shared/constants/slate';

import { toggleMarkWorkaround } from '../utils';

const {
  blockquote,
  li,
  ul,
  ol,
  heading,
  codeBlock,
  headline,
} = NT;



// NOTE: just allow for only one heading level..
// before: /^(#{1,2})$/,
const toHeading = {
  trigger: 'space',
  before: /^(#{1})$/,
  transform: (change, e, matches) => {
    const { document: doc, startBlock, } = change.value;

    if (doc.getDepth(startBlock.key) > 1) {
      change.operations = List();
      const [ marker ] = matches.before;
      return change.insertText(marker).insertText(' ');
    }

    const [ hashes ] = matches.before;

    // Let it start from h2
    const level = hashes.length + 1;

    return change.setBlock({
      type: heading,
      data: { level },
    });
  },
  ignoreIn: [ headline ],
};

const toBlockquote = {
  before: /^(>)$/,
  trigger: 'space',
  transform: (change, e, matches) => {
    const { document: doc, startBlock, } = change.value;

    // Only allow blockquote at top level block.
    // startBlock and endBlock should be the same..
    if (doc.getDepth(startBlock.key) > 1) {
      change.operations = List();
      const [ marker ] = matches.before;
      return change.insertText(marker).insertText(' ');
    }

    return change.setBlock(blockquote);
  },
  ignoreIn: [ headline ],
};


const toCodeMark = {
  before: /(`(?=.{1}$)[^`\s]|`[^`\s][^`]*[^`\s])$/,
  trigger: '`',
  transform: (change, e, matches) => {
    const { document: doc, startBlock } = change.value;
    const topLevelBlock = doc.getFurthestBlock(startBlock.key) || startBlock;

    const ignoreIn = [ headline, codeBlock ];
    const shouldBeIgnored = ignoreIn.includes(topLevelBlock.type);

    change.operations = List();
    const [ marker ] = matches.before;
    const { index } = matches.before;

    if (shouldBeIgnored) {
      return change.insertText(marker).insertText(e.key);
    }

    const string = marker.slice(1);

    change
      .insertText(string)
      .moveOffsetsTo(index, index + string.length)

    return toggleMarkWorkaround(change, MT.code)
      .collapseToEnd()
      .toggleMark(MT.code)
      .insertText(' ')
  },
  ignoreIn: [ headline ],
};


const MakeCodeBlockRule = (plugin) => ({
  trigger: '`',
  before: /^(`{2})$/,
  transform: (change, e, matches) => {
    const { document: doc, startBlock, } = change.value;

    if (doc.getDepth(startBlock.key) > 1) {
      change.operations = List();
      const [ marker ] = matches.before;
      return change.insertText(marker).insertText('`');
    }

    return plugin.changes.wrapCodeBlock(change).focus();
  },
  ignoreIn: [ headline ],
});


const makeListTransformFunc = (plugin, listNodeType) => (change, e, matches) => {
  const { value } = change;
  const { document: doc, startBlock } = change.value;

  const isInList = plugin.utils.isSelectionInList(value);
  const topLevelBlock = doc.getFurthestBlock(startBlock.key) || startBlock;
  const ignoreIn = [
    headline,
    heading,
    codeBlock,
  ];
  const shouldBeIgnored = ignoreIn.includes(topLevelBlock.type);

  if (isInList || shouldBeIgnored) {
    change.operations = List();
    const [ marker ] = matches.before;
    return change.insertText(marker).insertText(' ');
  }

  return change.setBlock(li).wrapBlock(listNodeType);
};

const MakeBulletedListRule = (plugin) => ({
  before: /^(\+|\*|-)$/,
  trigger: 'space',
  transform: makeListTransformFunc(plugin, ul),
  ignoreIn: [ headline ],
});

const MakeNumberedListRule = (plugin) => ({
  // Medium only supports a numbered list starting with 1 too
  before: /^(1\.)$/,
  trigger: 'space',
  transform: makeListTransformFunc(plugin, ol),
  ignoreIn: [ headline ],
});


const rules = {
  toHeading,
  toBlockquote,
  toCodeMark,
  MakeCodeBlockRule,
  MakeBulletedListRule,
  MakeNumberedListRule,
};


export default rules;



// WEBPACK FOOTER //
// ./src/components/slate/plugins/AutoReplaceRules.js